<template>
    <Teleport to="body">
        <Transition name="app-overlay-fade">
            <div
                v-if="loading"
                class="app-loading-overlay fixed inset-0 flex items-center justify-center bg-base-100/80 backdrop-blur-sm"
            >
                <span class="loading loading-spinner loading-lg text-primary"></span>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import { useTimeoutFn } from '@vueuse/core';
import { router } from '@inertiajs/vue3';
import { useAppLoading } from '@/composables/useAppLoading';

const { loading, show, hide } = useAppLoading();

const { start: startShowDelay, stop: stopShowDelay } = useTimeoutFn(show, 200, {
    immediate: false,
});
let stopStart: (() => void) | undefined;
let stopFinish: (() => void) | undefined;

onMounted(() => {
    stopStart = router.on('start', () => {
        stopShowDelay();
        startShowDelay();
    });
    stopFinish = router.on('finish', () => {
        stopShowDelay();
        hide();
    });
});

onBeforeUnmount(() => {
    stopShowDelay();
    stopStart?.();
    stopFinish?.();
});
</script>

<style scoped>
.app-loading-overlay {
    z-index: 2147483647;
}

.app-overlay-fade-enter-active,
.app-overlay-fade-leave-active {
    transition: opacity 0.15s ease;
}
.app-overlay-fade-enter-from,
.app-overlay-fade-leave-to {
    opacity: 0;
}
</style>
